import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f54f45ea")

_pushScopeId("data-v-f54f45ea")
const _hoisted_1 = { class: "reel-catalog-library mt-4" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-0" }, "Community clips", -1)
const _hoisted_4 = { class: "text-muted fs-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-3" }, " Upload portrait videos or photos from your community, events, or training sessions. Use content you own. Avoid income guarantees or misleading opportunity claims. ", -1)
const _hoisted_7 = { class: "progress h-8px w-100 mb-3" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-2 mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_10 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_11 = {
  key: 2,
  ref: "gridRef",
  class: "reel-catalog-library__grid"
}
const _hoisted_12 = { class: "reel-catalog-library__thumb" }
const _hoisted_13 = {
  key: 1,
  class: "reel-catalog-library__video"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-video text-white" }, null, -1)
const _hoisted_15 = { class: "reel-catalog-library__meta" }
const _hoisted_16 = { class: "text-muted fs-9" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("span", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.files.length) + " / " + _toDisplayString(_ctx.maxFiles) + " items · " + _toDisplayString(_ctx.formatBytes(_ctx.usedBytes)) + " / " + _toDisplayString(_ctx.formatBytes(_ctx.limitBytes)) + " ", 1),
        (_ctx.selectable && _ctx.selectedIds.length)
          ? (_openBlock(), _createBlock("span", _hoisted_5, " · " + _toDisplayString(_ctx.selectedIds.length) + " selected", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", {
        class: "progress-bar",
        role: "progressbar",
        style: { width: _ctx.storagePercent + '%' },
        "aria-valuenow": _ctx.storagePercent,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, null, 12, ["aria-valuenow"])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light-primary",
        disabled: _ctx.uploading || _ctx.files.length >= _ctx.maxFiles,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerUpload && _ctx.triggerUpload(...args)))
      }, _toDisplayString(_ctx.uploading ? "Uploading…" : "Upload video or photo"), 9, ["disabled"]),
      _createVNode("input", {
        ref: "fileInput",
        type: "file",
        accept: "video/*,image/jpeg,image/png,image/webp",
        class: "d-none",
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
      }, null, 544)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_9, "Loading catalog…"))
      : (!_ctx.files.length)
        ? (_openBlock(), _createBlock("div", _hoisted_10, " No community clips yet. "))
        : (_openBlock(), _createBlock("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
              return (_openBlock(), _createBlock("div", {
                key: file.id,
                class: ["reel-catalog-library__item", { 'reel-catalog-library__item--selected': _ctx.isSelected(file.id) }]
              }, [
                (_ctx.selectable)
                  ? (_openBlock(), _createBlock("label", {
                      key: 0,
                      class: ["reel-catalog-library__select", { 'reel-catalog-library__select--disabled': !_ctx.canSelect(file) }]
                    }, [
                      _createVNode("input", {
                        type: "checkbox",
                        checked: _ctx.isSelected(file.id),
                        disabled: !_ctx.canSelect(file),
                        onChange: ($event: any) => (_ctx.toggleSelection(file.id, $event))
                      }, null, 40, ["checked", "disabled", "onChange"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_12, [
                  (_ctx.thumbUrl(file))
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: _ctx.thumbUrl(file),
                        alt: file.originalFilename
                      }, null, 8, ["src", "alt"]))
                    : (_openBlock(), _createBlock("div", _hoisted_13, [
                        _hoisted_14
                      ])),
                  _createVNode("span", {
                    class: ["badge reel-catalog-library__status", _ctx.statusClass(file.status)]
                  }, _toDisplayString(file.status), 3)
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", {
                    class: "text-truncate fs-8 fw-semibold",
                    title: file.originalFilename
                  }, _toDisplayString(file.originalFilename), 9, ["title"]),
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formatBytes(file.fileSizeBytes)), 1)
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light reel-catalog-library__delete",
                  title: "Delete",
                  onClick: ($event: any) => (_ctx.confirmDelete(file))
                }, [
                  _hoisted_17
                ], 8, ["onClick"])
              ], 2))
            }), 128))
          ], 512))
  ]))
})